export const DepartmentType = {
  REPLACEMENT_PARTS: { id: "replacement parts" },
  BODY_PARTS: { id: "body parts" },
  AUTOMOTIVE_LIGHTINGS: { id: "automotive lightings" },
  TOOLS_EQUIPMENT: { id: "tools & equipment" },
  PERFORMANCE_PARTS: { id: "performance parts" },
  INTERIOR: { id: "interior" },
  EXTERIOR: { id: "exterior" },
  WHEELS_AND_TIRES: { id: "wheels & tires" },
  SPECIALTY_PARTS: { id: "specialty parts" },
};
